if (!customElements.get("a-shop-buttons")) {
  customElements.define(
    "a-shop-buttons",
    class AShopButtons extends HTMLElement {
      constructor() {
        super();
        this.buttons = this.querySelectorAll("button");
        this.buttons.forEach((btn) =>
          btn.addEventListener("click", this.handleClick.bind(this))
        );
      }

      variantChangeUnsubscriber = undefined;

      handleClick(e) {
        // Send tracking to data layer first, then change location
        this.dispatchCustomAnalyticsEvent("ShopAmazonClick", {
          variant_id: e.target.dataset.variant,
        });
        setTimeout(() => {
          window.location.href = e.target.dataset.href;
        }, 500);
      }

connectedCallback() {
  // Update button show if variant is switched on product page
  this.variantIdChangedUnsubscriber = subscribe(
    PUB_SUB_EVENTS.variantChange,
    (event) => {
      this.variantId = event.data.variant.id.toString();
      this.showVariantButton();
    }
  );
}


      showVariantButton() {
        this.hideVariantButtons();
        this.querySelector(
          `[data-variant="${this.variantId}"]`
        ).classList.remove("hidden");
      }

      hideVariantButtons() {
        this.buttons.forEach((btn) => btn.classList.add("hidden"));
      }

      dispatchCustomAnalyticsEvent = function (eventName, eventData = {}) {
        const timestamp = new Date().toISOString();
        const payload = {
          event_name: eventName,
          ...eventData,
          timestamp,
          url: window.location.href,
        };

        // Meta/Facebook Pixel
        if (typeof fbq === "function") {
          try {
            fbq("trackCustom", eventName, payload);
          } catch (e) {
            console.warn("Meta Pixel error:", e);
          }
        }

        // Google Analytics 4
        if (typeof gtag === "function") {
          try {
            gtag("event", eventName, payload);
          } catch (e) {
            console.warn("GA4 error:", e);
          }
        }

        // TikTok Pixel
        if (typeof ttq === "object" && typeof ttq.track === "function") {
          try {
            ttq.track(eventName, payload);
          } catch (e) {
            console.warn("TikTok Pixel error:", e);
          }
        }

        // Klaviyo (requires Klaviyo Web Tracking)
        if (typeof _learnq === "object") {
          try {
            _learnq.push(["track", eventName, payload]);
          } catch (e) {
            console.warn("Klaviyo error:", e);
          }
        }
      };
    }
  );
}
